// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'

import vSelectPage from 'v-selectpage'
import 'font-awesome/css/font-awesome.css'
import 'element-ui/lib/theme-chalk/index.css'
require('../static/plugins/DataTables/media/css/dataTables.bootstrap.min.css');
require('../static/plugins/DataTables/extensions/AutoFill/css/autoFill.bootstrap.min.css');
require('../static/plugins/DataTables/extensions/Responsive/css/responsive.bootstrap.min.css');
require('../static/plugins/bootstrap-datepicker/css/bootstrap-datepicker.css');
require('../static/plugins/bootstrap-datepicker/css/bootstrap-datepicker3.css');
require('../static/plugins/bootstrap-colorpicker/css/bootstrap-colorpicker.min.css');
require('../static/plugins/bootstrap-timepicker/css/bootstrap-timepicker.min.css');
require('../static/plugins/jquery-tag-it/css/jquery.tagit.css');
require('../static/plugins/bootstrap-daterangepicker/daterangepicker.css');
require('../static/plugins/select2/dist/css/select2.min.css');
require('../static/plugins/bootstrap-eonasdan-datetimepicker/build/css/bootstrap-datetimepicker.min.css');
require('../static/plugins/bootstrap-colorpalette/css/bootstrap-colorpalette.css');
require('../static/plugins/jquery-simplecolorpicker/jquery.simplecolorpicker.css');
require('../static/plugins/jquery-simplecolorpicker/jquery.simplecolorpicker-fontawesome.css');
require('../static/plugins/jquery-simplecolorpicker/jquery.simplecolorpicker-glyphicons.css');
require('../static/plugins/simple-line-icons/css/simple-line-icons.css');
require('../static/plugins/jquery-ui/jquery-ui.min.css');
require('../static/plugins/bootstrap/4.1.3/css/bootstrap.min.css');
// require('../static/plugins/font-awesome/5.3/css/all.min.css');
require('../static/plugins/animate/animate.min.css');
require('../static/css/default/style.min.css');
require('../static/css/default/style-responsive.min.css');
require('../static/css/default/theme/default.css');
Vue.config.productionTip = false
Vue.use(vSelectPage)

Vue.use(ElementUI)

/* eslint-disable no-new */

// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   next()
// })

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js